/** @jsxImportSource @emotion/react */

'use client';
import CheckIcon from '@mui/icons-material/Check';
import type { ReactNode } from 'react';

import Button from '../Button';
import * as styles from './styles';

interface SelectButtonProps {
  selected?: boolean;
  onClick?: () => void;
  disabled?: boolean;
  type?: 'button' | 'submit' | 'reset';
  size?: 'small' | 'medium' | 'large';
  color?: 'inherit' | 'primary' | 'secondary' | 'success' | 'error' | 'info' | 'warning';

  children: ReactNode;
}

export default function SelectButton({
  selected,
  onClick,
  disabled,
  type = 'button',
  size = 'medium',
  color = 'secondary',
  children,
}: SelectButtonProps) {
  return (
    <Button
      onClick={onClick}
      type={type}
      startIcon={selected && <CheckIcon />}
      variant={selected ? 'contained' : 'outlined'}
      css={[styles.selectButton]}
      disabled={disabled}
      color={color}
      size={size}
    >
      {children}
    </Button>
  );
}
